<template>
  <app-config>
    <app-box padding>
      <app-box margin>
        <app-title label="Temas" />
      </app-box>

      <app-box background margin>
        <app-text class="mb-5">
          Deixe o e.Mix HelpDesk do seu jeito utilizando nossos temas. Os temas
          alteram as cores dos elementos primários e secundários.<br />
          Clique em uma cor abaixo e veja o tema ser aplicado imediatamente.
        </app-text>

        <tool-colors />
      </app-box>

      <app-box background margin title="Experimente as cores com o Modo Escuro">
        <app-text class="mb-5">
          O modo escuro altera as cores brilhantes padrões do plano de fundo e
          dos elementos no e.Mix HelpDesk para cores mais escuras, que são mais
          confortáveis aos olhos em ambientes com baixa luz ou se você preferir
          uma interface menos brilhante.
        </app-text>

        <app-input-label :margin="false" background>
          Alternar modo escuro
          <app-switch
            :active="storeNightlyMode"
            big
            class="ml-3"
            v-on:change="toggleNightlyMode()"
          />
        </app-input-label>
      </app-box>
    </app-box>
  </app-config>
</template>

<script>
import AppConfig from '@/views/config/Index.vue'
import ToolColors from './ToolColors.vue'

export default {
  components: {
    AppConfig,

    ToolColors
  },

  computed: {
    storeNightlyMode () {
      return this.$store.getters.nightlyMode
    }
  },

  methods: {
    toggleNightlyMode () {
      this.$store.commit('toggleNightlyMode')
    }
  }
}
</script>
